import React from 'react';

/**
 * Componente de cabeçalho personalizado do salão
 * Exibe o logo e/ou nome do salão de acordo com as configurações
 * 
 * @param {Object} props - Propriedades do componente
 * @param {Object} props.salonConfig - Configurações do salão
 * @param {string} props.salonConfig.name - Nome do salão
 * @param {string} props.salonConfig.logoUrl - URL do logo do salão
 * @param {string} props.salonConfig.primaryColor - Cor primária do salão
 * @param {string} props.salonConfig.fontFamily - Família de fonte do salão
 * @param {string} props.salonConfig.headerStyle - Estilo do cabeçalho ('logo-only', 'text-only', 'combined')
 */
const SalonHeader = ({ salonConfig }) => {
  if (!salonConfig) return null;
  
  const { 
    name = '',
    logoUrl = '',
    primaryColor = '#4F46E5',
    headerStyle = 'combined'
  } = salonConfig;
  
  const renderLogo = () => {
    if (!logoUrl) return null;
    
    return (
      <div className="flex justify-center mb-2">
        <img 
          src={logoUrl} 
          alt={`Logo ${name}`} 
          className="h-16 object-contain"
        />
      </div>
    );
  };
  
  const renderName = () => {
    if (!name) return null;
    
    return (
      <h1 
        className="text-center text-xl font-semibold" 
        style={{ color: primaryColor }}
      >
        {name}
      </h1>
    );
  };
  
  return (
    <header className="bg-white shadow-sm py-4 px-6 mb-6">
      {headerStyle === 'logo-only' && renderLogo()}
      {headerStyle === 'text-only' && renderName()}
      {headerStyle === 'combined' && (
        <>
          {renderLogo()}
          {renderName()}
        </>
      )}
    </header>
  );
};

export default SalonHeader; 